import {
  CatalogQueryType,
  CatalogSearchResultData,
  CatalogSearchResultItem,
  ResourceCatalogComponentApi,
  ResourceCatalogComponentApiPaged,
} from './types';

import { DevHubGrid, DevHubLink } from '@devxdiscover/devhub-ui';
import {
  CATCH_ALL_GROUP_NAME,
  getOrgForScmSlug,
  orgNameToNamespace,
} from '@devxdiscover/devhub-common';

/**
 * ApiResult returns API details for the search results
 * @param data a row containing data for the API
 */
export const ApiDetails = (data: CatalogSearchResultItem) => {
  const componentApiData = data.item as ResourceCatalogComponentApi;
  return (
    <DevHubGrid container>
      <DevHubGrid item xs={1} />
      <DevHubGrid container item xs={11} spacing={1}>
        {componentApiData.description && (
          <>
            <DevHubGrid item xs={2}>
              <span style={{ fontWeight: 'bold' }}>Description</span>
            </DevHubGrid>
            <DevHubGrid item xs={10}>
              {componentApiData.description}
            </DevHubGrid>
          </>
        )}
        <DevHubGrid item xs={2}>
          <span style={{ fontWeight: 'bold' }}>Repository</span>
        </DevHubGrid>
        <DevHubGrid item xs={10}>
          <DevHubLink href={componentApiData.sourceLocationUrl} target="_blank">
            {componentApiData.sourceLocationUrl}
          </DevHubLink>
        </DevHubGrid>
        <DevHubGrid item xs={2}>
          <span style={{ fontWeight: 'bold' }}>ID</span>
        </DevHubGrid>
        <DevHubGrid item xs={10}>
          {componentApiData.id}
        </DevHubGrid>
      </DevHubGrid>
    </DevHubGrid>
  );
};

/**
 * convertApiSearchResult converts the API search results into a format that can be displayed
 * @param apiData the data returned from the fusion query
 */
export const convertApiSearchResult = (
  apiData: ResourceCatalogComponentApiPaged,
): CatalogSearchResultData => {
  const apiItems: CatalogSearchResultItem[] = (
    apiData.resources.componentApisPaged
      .componentApis as ResourceCatalogComponentApi[]
  ).map(item => ({
    expandable: false,
    name: item.name,
    title: item.title,
    kind: item.type,
    lifecycle: item.lifecycle,
    id: item.id,
    type: CatalogQueryType.API,
    ownerOrg: `${orgNameToNamespace(
      getOrgForScmSlug(item.scmSlug),
    )}/${CATCH_ALL_GROUP_NAME}`,
    item: item,
  }));

  return {
    items: apiItems,
    totalCount: apiData.resources.componentApisPaged.totalCount,
  };
};
